import * as Types from '../../Models/ViewManagementModel';
import * as HistoryEnumTypes from '../../Models/EnumTypes/HistoryEnumTypes';
import * as ActionTypes from '../Actions/EnumTypes/ActionEnumTypes';
import { ViewsManagemenetAction } from '../Actions/Models/ViewsManagementActionModel';

export type State = Types.ViewManagementStore;

export const initialState: State = {
    sidebarMenuExpanded: false,
    loaderVisible: true,
    detailsSidebarloaderVisible: false,
    detailsPanelVisible: true,
    activeLanguage: localStorage.getItem('activeLanguage') || 'pl',
    carRideDetailsVisible: false,
    activeRideView: null,
    activeZoneView: HistoryEnumTypes.ZonesViewType.POI,
    activeCarDetailsView: HistoryEnumTypes.CarDetailsViewType.CAR_DETAILS,
    activeAddingAOI: false,
    activeAddingPOI: false,
    vehicleListVisible: false,
    popupVisible: false,
    popupData: null,
    summaryMapView: localStorage.getItem('summaryMapView')
        ? JSON.parse(localStorage.getItem('summaryMapView'))
        : {
              car: true,
              poi: false,
              aoi: false,
            alert: false
          },
    addPoiPopupPosition: {
        lat: null,
        lng: null
    },
    alertListTypeVisible: 'cars'
};

export function viewManagementReducer(state: State = initialState, action: ViewsManagemenetAction): State {
    switch (action.type) {
        case ActionTypes.ViewManagement.TOGGLE_SIDEBAR_MENU: {
            return {
                ...state,
                sidebarMenuExpanded: !state.sidebarMenuExpanded
            };
        }
        case ActionTypes.ViewManagement.SHOW_LOADER: {
            if (!state.loaderVisible) {
                return {
                    ...state,
                    loaderVisible: true
                };
            } else {
                return state;
            }
        }
        case ActionTypes.ViewManagement.HIDE_LOADER: {
            if (state.loaderVisible) {
                return {
                    ...state,
                    loaderVisible: false
                };
            } else {
                return state;
            }
        }
        case ActionTypes.ViewManagement.TOGGLE_DETAILS_PANEL: {
            return {
                ...state,
                detailsPanelVisible: !state.detailsPanelVisible
            };
        }
        case ActionTypes.ViewManagement.SHOW_DETAILS_PANEL: {
            return {
                ...state,
                detailsPanelVisible: true
            };
        }
        case ActionTypes.ViewManagement.HIDE_DETAILS_PANEL: {
            return {
                ...state,
                detailsPanelVisible: false
            };
        }
        case ActionTypes.ViewManagement.SET_ACTIVE_PAGE: {
            return {
                ...state,
                activePage: action.payload,
                activeRideView: null,
                activeZoneView: HistoryEnumTypes.ZonesViewType.POI
            };
        }
        case ActionTypes.ViewManagement.SET_LANGUAGE: {
            localStorage.setItem('activeLanguage', action.payload.activeLanguage);

            return {
                ...state,
                activeLanguage: action.payload.activeLanguage
            };
        }
        case ActionTypes.ViewManagement.SHOW_CARRIDE_DETAILS_VIEW: {
            return {
                ...state,
                carRideDetailsVisible: true
            };
        }
        case ActionTypes.ViewManagement.HIDE_CARRIDE_DETAILS_VIEW: {
            return {
                ...state,
                carRideDetailsVisible: false
            };
        }
        case ActionTypes.ViewManagement.SET_ACTIVE_RIDE_VIEW_TYPE: {
            return {
                ...state,
                activeRideView: action.payload.activeRideView
            };
        }
        case ActionTypes.ViewManagement.SET_ACTIVE_CAR_DETAILS_VIEW: {
            return {
                ...state,
                activeCarDetailsView: action.payload.activeCarDetailsView
            };
        }
        case ActionTypes.ViewManagement.SET_ACTIVE_ZONE_VIEW: {
            return {
                ...state,
                activeZoneView: action.payload.activeZoneView,
                activeAddingAOI: false,
                activeAddingPOI: false
            };
        }
        case ActionTypes.ViewManagement.TOGGLE_ADDING_AOI: {
            return {
                ...state,
                activeAddingAOI: !state.activeAddingAOI
            };
        }
        case ActionTypes.ViewManagement.SHOW_ADDING_AOI: {
            return {
                ...state,
                activeAddingAOI: true
            };
        }
        case ActionTypes.ViewManagement.HIDE_ADDING_AOI: {
            return {
                ...state,
                activeAddingAOI: false
            };
        }
        case ActionTypes.ViewManagement.SHOW_ADDING_POI: {
            return {
                ...state,
                activeAddingPOI: true
            };
        }
        case ActionTypes.ViewManagement.HIDE_ADDING_POI: {
            return {
                ...state,
                activeAddingPOI: false
            };
        }
        case ActionTypes.ViewManagement.SHOW_VEHICLE_LIST: {
            return {
                ...state,
                vehicleListVisible: true
            };
        }
        case ActionTypes.ViewManagement.HIDE_VEHICLE_LIST: {
            return {
                ...state,
                vehicleListVisible: false
            };
        }
        case ActionTypes.ViewManagement.SHOW_POPUP: {
            return {
                ...state,
                popupVisible: true,
                popupData: action.payload.popupData
            };
        }
        case ActionTypes.ViewManagement.HIDE_POPUP: {
            return {
                ...state,
                popupVisible: false,
                popupData: null
            };
        }
        case ActionTypes.ViewManagement.MANAGE_MAP_SUMMARY: {
            const summaryMapView = { ...state.summaryMapView };
            summaryMapView[action.payload.type] = !summaryMapView[action.payload.type];
            localStorage.setItem('summaryMapView', JSON.stringify(summaryMapView));
            return {
                ...state,
                summaryMapView
            };
        }
        case ActionTypes.ViewManagement.SHOW_ZONES: {
            const summaryMapView = { ...state.summaryMapView };
            summaryMapView.aoi = true;
            summaryMapView.poi = true;
            summaryMapView.alert = false;
            return {
                ...state,
                summaryMapView
            };
        }
        case ActionTypes.ViewManagement.CHANGE_ALERT_LIST_TYPE: {
            return {
                ...state,
                alertListTypeVisible: action.payload.type,
                vehicleListVisible: true
            };
        }
        case ActionTypes.ViewManagement.SHOW_DETAILS_SIDEBAR_LOADER: {
            if (state.detailsSidebarloaderVisible === false) {
                return {
                    ...state,
                    detailsSidebarloaderVisible: true
                };
            } else {
                return state;
            }
        }
        case ActionTypes.ViewManagement.HIDE_DETAILS_SIDEBAR_LOADER: {
            if (state.detailsSidebarloaderVisible) {
                return {
                    ...state,
                    detailsSidebarloaderVisible: false
                };
            } else {
                return state;
            }
        }
        case ActionTypes.ViewManagement.SHOW_ALERTS: {
            const summaryMapView = { ...state.summaryMapView };
            summaryMapView.aoi = false;
            summaryMapView.poi = false;
            summaryMapView.alert = true;
            return {
                ...state,
                summaryMapView
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/Redux/Reducers/ViewManagementReducer.ts